import type {ReactElement} from 'react';
import React from 'react';
import {LayoutOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/layout-option';
import {LayoutOptions} from '@Components/contextual-menu/components/contextual-menu-layout-button';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';

interface TableLayoutOptionProps {
  onClickLayout(): void;
}

export function TableLayoutOption({...props}: TableLayoutOptionProps): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;

  if (activeItem && !activeItem.isSchedule()) {
    return null;
  }

  return (
    <LayoutOption
      onClickLayout={(): void => {
        props.onClickLayout();
      }}
      layoutFor={LayoutOptions.SCHEDULE}
    />
  );
}
